import { render, staticRenderFns } from "./UpdatePatientProfileForm.vue?vue&type=template&id=5f39cea3&"
import script from "./UpdatePatientProfileForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePatientProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports